/* eslint-disable */

import React from "react";
// google auth
import { useGoogleLogin } from "@react-oauth/google";
// material ui
import { Button as MUIButton, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { useFlags } from "launchdarkly-react-client-sdk";
import { analytics } from "services/analytics";

import Button from "components/common/Button";

// router
import { useParams, useLocation, useNavigate } from "react-router-dom";
// redux
import { useSelector, useDispatch } from "react-redux";
import { GoogleSigunp, ResetGoogleSigunp } from "../../../../store/actions/Google/Google_signup";

import { s3ImagesBaseURL } from "util/APIBaseUrl";

// icons
import GoogleIcon from "../../../Icons/googleIconSmall.png";
import { SignInScreenPermissions } from "../SignIn.enum";
import { DropdownData } from "../../../../store/actions/DropdownData";
import { ResetAuthUser } from "../../../../store/actions/AuthUser";
import { GetPlatformConfig } from "../../../../store/actions/PlatformConfig";
import { UserAdditionalInfo } from "../../../../store/actions/UserAdditionalInfo";

import { ADD_CUSTOMER_INFO_ROUTE } from "constants/routes";
import { resolvePostLoginRoute } from "util/postLoginRedirect";

import "./GoogleSignup.scss";

function GoogleAuth(props) {
  const { changeScreen = () => {}, loginPortal, buttonText = "Continue with Google" } = props;
  const { loginRebrand } = useFlags();
  const history = useNavigate();
  const location = useLocation();

  // redux
  const dispatch = useDispatch();

  const [googleResponse, setGoogleResponse] = React.useState({});

  // redux state
  const googleSignupInfo = useSelector((state) => state.GoogleSignup.googleSignupInfo);

  const userAdditionalInfo = useSelector((state) => state.UserAdditionalInfo.userAdditionalInfo);

  const dropdownData = useSelector((state) => state.DropdownData.dropdownData);

  // functions

  const onLoginSuccess = async (googleData) => {
    let googleRequest = "";
    dispatch(ResetGoogleSigunp({}));
    dispatch(ResetAuthUser({}));
    setGoogleResponse(googleData);
    // if (googleData && location.pathname == "/") {

    if (googleData) {
      if (loginPortal == "customer") {
        googleRequest = "customers/googleAuth";
      } else if (loginPortal == "employee") {
        googleRequest = "employee/googleAuth";
      } else if (location.pathname == "/admin") {
        googleRequest = "admin/googleAuth";
      }
    }

    dispatch(
      GoogleSigunp({
        // customerData: customerData,
        googleToken: googleData.code,
        method: "POST",
        request: googleRequest,
      })
    );
  };

  const onLoginFailure = (response) => {
    // localStorage.removeItem("accessToken");
    // history("/");
    dispatch(ResetAuthUser({}));
  };

  React.useEffect(() => {
    const loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"));
    const accesstoken = localStorage.getItem("accessToken");

    if (accesstoken != null && accesstoken != "undefined" && loggedInUser != null && loggedInUser != "undefined") {
      dispatch(DropdownData());
    }
  }, [googleSignupInfo]);

  React.useEffect(() => {
    let loggedInUser = {};
    const accesstoken = localStorage.getItem("accessToken");

    if (dropdownData?.ok) {
      if (accesstoken != null && accesstoken != "undefined") {
        loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"));
        if (loggedInUser != null && loggedInUser != undefined) {
          analytics.track("Logged In", {
            channel: "google",
            name: loggedInUser?.name,
            email: loggedInUser?.email,
            userID: loggedInUser?.userId,
            accountType: loggedInUser?.type,
          });

          if (loggedInUser?.type == "customer") {
            if (loggedInUser?.setupCompany) {
              // Detour, not a destination — hands off to a screen-swap rather than returning, so
              // the saved route is left stored for whichever branch below eventually navigates.
              loginRebrand ? history(ADD_CUSTOMER_INFO_ROUTE) : changeScreen(SignInScreenPermissions.ADD_CUSTOMER_INFO);
            } else if (!loggedInUser?.bankAttached && userAdditionalInfo.status === "enabled") {
              // Same as above: a screen-swap detour, not a destination — do not consume here.
              changeScreen(SignInScreenPermissions.ADD_PAYMENT_METHOD);
            } else {
              history(resolvePostLoginRoute("/main/dashboard"));
            }
          } else if (loggedInUser?.type == "employee") {
            dispatch(UserAdditionalInfo(`employee/${loggedInUser.userId}`));
            history(resolvePostLoginRoute("/main/dashboard"));
          } else {
            history(resolvePostLoginRoute("/main/dashboard"));
          }
        }
      }
    } else {
    }
  }, [dropdownData, userAdditionalInfo]);

  const login = useGoogleLogin({
    flow: "auth-code",
    scope: "openid email profile",
    ux_mode: "popup",
    onSuccess: onLoginSuccess,
    onError: onLoginFailure,
  });

  return loginRebrand ? (
    <div className="google-signup-button-container">
      <Button
        variant="outlined"
        size="large"
        isFullWidth
        startIcon={
          <img src={`${s3ImagesBaseURL}/google-btn-icon.svg`} alt="google btn" className="mr-05" width="26px" />
        }
        label={buttonText}
        onClick={() => login()}
        className="google-signup-button"
      />
    </div>
  ) : (
    <Box>
      <MUIButton
        type="submit"
        variant="contained"
        fullWidth
        onClick={() => login()}
        sx={{
          backgroundColor: "#FFFFFF",
          height: "54px",
          fontFamily: "Poppins-Regular !important",
          fontWeight: "500",
          lineHeight: "20",
          borderRadius: "99px",
          fontSize: "16px",
          color: "var(--color-primitives-primary-600)",
          boxShadow: "2px 5px 7px rgba(2, 0, 110, 0.12)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "12px",
          ":hover": {
            bgcolor: "primary.main",
            color: "white",
          },
        }}
      >
        <div>
          <img src={GoogleIcon} style={{ marginRight: 8 }} alt="gmail icon" width="26px" />
        </div>
        <Typography>Continue with Google</Typography>
      </MUIButton>
    </Box>
  );
}
export default GoogleAuth;
